import React from 'react';
import { useStore } from 'effector-react';
import styled from 'styled-components';
import { Flex, Box, Text } from 'rebass';
import { Link } from 'react-router-dom';
import { Trans } from '@lingui/macro';
import { $notificationList } from '@features/notifications/models/notifications-flow';

import { DefaultUser, Bell, Person, Logout, Dashboard } from '@oca/icons';
import { Avatar, Typography, IconButton, Menu } from '@oca/ui';

import { history } from '@lib/routing';
import { createTransition } from '@oca/ui/theme';
import { getOrganizationMeta } from '../lib/get-meta';
import { $session, logoutRequesting } from '../model/auth';

import { openNotificationsPanel } from '../model/panel-toggle-flow';
import { headerWidgetAreaId } from '../constants';
import { AppBreadcrumb } from './page-breadcrumb';

export function Header() {
  const meta = getOrganizationMeta(process.env.REACT_APP_ORGANIZATION);
  const notificationList = useStore($notificationList);
  const notificationCount = (notificationList.results || []).filter(
    item => !item.isRead,
  ).length;
  const user = useStore($session) || {};
  // const Logo = meta.logo;

  return (
    <Wrapper
      alignItems="center"
      justifyContent="space-between"
      px={[4, 0, 0, 0]}
      py={1}
      mx="auto"
    >
      <Link to="/" style={{ textDecoration: 'none' }}>
        <CenteredFlex>
          <AppBreadcrumb />
        </CenteredFlex>
      </Link>
      <CenteredFlex>
        <div id={headerWidgetAreaId} />
        <NotificationWrap onClick={() => openNotificationsPanel()}>
          <IconButton>
            <Bell />
          </IconButton>
          {Boolean(notificationCount) && (
            <NotificationCount>
              <Text color="#fff" fontSize={10}>
                {notificationCount < 20 ? notificationCount : '20+'}
              </Text>
            </NotificationCount>
          )}
        </NotificationWrap>
        <User />
        <Typography
          variant="h4"
          color="textSecondary"
          fontWeight={400}
          fontFamily="Roboto Condensed"
        >
          <UserName>
            {user.firstName && user.lastName
              ? `${user.firstName} ${user.lastName}`
              : user.username}
          </UserName>
        </Typography>
      </CenteredFlex>
    </Wrapper>
  );
}

function User() {
  const user = useStore($session) || {};

  return (
    <React.Fragment>
      <Menu
        placement="bottom-end"
        anchor={
          <AvatarWrapper tabIndex={0}>
            <Avatar src={user.avatar} size={30}>
              <DefaultUser />
            </Avatar>
          </AvatarWrapper>
        }
        usePortal
      >
        <Menu.Item
          icon={<Person />}
          onClick={() => history.push(`/hr/employees/${user.username}`)}
        >
          <Typography>
            <Trans>Profile</Trans>
          </Typography>
        </Menu.Item>
        <Menu.Item icon={<Logout />} onClick={logoutRequesting}>
          <Typography>
            <Trans>Logout</Trans>
          </Typography>
        </Menu.Item>
      </Menu>
    </React.Fragment>
  );
}

const UserName = styled.span`
  color: #475467;
  font-family: 'Roboto Condensed';
  font-weight: 400;
`;

const Wrapper = styled(Flex)`
  position: relative;
  margin: 0 auto;
  background: white;
  border-radius: 12px;
`;

const CenteredFlex = styled(Flex)`
  align-items: center;
  & > *:not(:last-child) {
    margin-right: 10px;
  }
`;

const NotificationWrap = styled(Box)`
  position: relative;
`;

const NotificationCount = styled(Flex)`
  position: absolute;
  right: -5px;
  top: -5px;
  width: 18px;
  height: 18px;
  border-radius: 15px;
  align-items: center;
  justify-content: center;
  background-color: #7738fff5;
`;

const AvatarWrapper = styled.div`
  cursor: pointer;
  border-radius: 50%;
  border: 2px solid transparent;
  transition: ${createTransition(['border-color'])};
  outline: none;
  &:hover,
  &:focus {
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;
